import { Component } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { TranslocoService } from "@ngneat/transloco";
import { BlockBaseComponent } from "../../scene-blocks/block-base/block-base.component";
import { LocalStoreService, StoreSelectorsService } from "../../../../services";
import { actionAddScene, actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { IAnimationEngine, IPlayerProps, ISceneBlock } from "../../../../interfaces";
import { SceneMimeTypes } from '../../scene-blocks/mime-constants';
import * as _ from "lodash";

const PreviewSceneName = '__ani__preview__scene1__';
const PreviewSceneNameForTyping = '__ani__preview__scene__typing__';
const PreviewLabel1 = "A";
const PreviewLabel2 = "B";
const PreviewTypingLabel1 = "AaBbCc";
const PreviewTypingLabel2 = "XxYyZz";

@Component({
    selector: "app-block-animation-preview",
    templateUrl: "./block-animation-preview.component.html",
    styleUrls: ["./block-animation-preview.component.scss"],
    standalone: false
})

export class BlockAnimationPreviewComponent extends BlockBaseComponent {
    previewWidth = 240;
    previewHeight = 150;
    previewFontSize = 100;
    previewTypingFontSize = 50;
    privateScenes: Array<IPlayerProps> = [];
    loadingPreview = false;
    previewSceneId = null;
    currentAnimation: IAnimationEngine = null;
    isTyping = false;

    constructor(
        public override storeSelector: StoreSelectorsService,
        private translocoService: TranslocoService,
        private toastr: ToastrService,
        protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector);
    }

    override onInit() {
        this.cod(
            this.storeSelector.getScenes(false, false, true).subscribe((i_scenes) => {
                this.privateScenes = i_scenes;
            })
        );
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        if (this.currentAnimation && this.currentAnimation != this.sceneItem.Data[0]?.Animation?.[0]) {
            this.previewSceneId = null;
        }
        super.componentStoreUpdates();
    }

    previewAnimation() {
        this.loadingPreview = true;

        // Set current animation and check if it has typing property
        this.currentAnimation = this.sceneItem.Data[0]?.Animation?.[0];
        this.isTyping = (this.currentAnimation.In && this.currentAnimation.In[0].$.textTypingFrq != '0') || (this.currentAnimation.Out && this.currentAnimation.Out[0].$.textTypingFrq != '0');

        // Check if there is already existing preview scene. If not, create new
        const s = this.privateScenes.find((i_scene) => {
            return i_scene.Player.$.label === (this.isTyping ? PreviewSceneNameForTyping : PreviewSceneName);
        });
        if (!s) {
            this.previewSceneId = this.createAniPreviewSceneWithLabelQueue();
        } else {
            this.previewSceneId = s.Player.$.id;
        }

        if (!this.previewSceneId) {
            this.toastr.error(this.translocoService.translate('toast.failedCreateAnimationPreview', {}, this.translocoService.getActiveLang()));
            this.loadingPreview = false;
            return;
        }

        // Update the animation of Preview Scene with current scene item animation
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.previewSceneId,
            sceneItemId: this.previewSceneId,
            values: [{
                key: 'Animation',
                value: [this.currentAnimation],
                storePath: `Data[0]`
            }],
            disableCRUD: true
        }));
        
        // Render animation preview scene
        setTimeout(() => {
            this.loadingPreview = false;
        });
    }

    private createAniPreviewSceneWithLabelQueue() {
        const sceneId = _.uniqueId("__");
        const sceneBlock = this.storeSelector.getBlockLabelByFileType('scene');
        const scene: ISceneBlock = sceneBlock.template;
        const newScene = {Player: scene};

        // set scene layout
        newScene.Player.$.id = sceneId;
        newScene.Player.$.player = sceneBlock.id;
        newScene.Player.$.private_child = true;
        newScene.Player.Data[0].Layout[0].$.width = `${this.previewWidth}`;
        newScene.Player.Data[0].Layout[0].$.height = `${this.previewHeight}`;
        newScene.Player.$.label = this.isTyping ? PreviewSceneNameForTyping : PreviewSceneName;
        newScene.Player.$.mimeType = SceneMimeTypes.Player;
        const playerId = _.uniqueId("__");

        const players = [];

        const blockTemplate = _.cloneDeep(this.storeSelector.blockLabels.LABELQUEUE.template);
        blockTemplate.$.id = playerId;
        blockTemplate.Data[0].Layout[0].$.x = "0";
        blockTemplate.Data[0].Layout[0].$.y = "0";
        blockTemplate.Data[0].Layout[0].$.width = `${this.previewWidth}`;
        blockTemplate.Data[0].Layout[0].$.height = `${this.previewHeight}`;

        blockTemplate.Data[0].LabelQueue[0].Font[0].$.fontSize = `${this.isTyping ? this.previewTypingFontSize : this.previewFontSize}`;
        blockTemplate.Data[0].LabelQueue[0].TextList[0].Text = [
            {
                "$": {
                    "text": this.isTyping ? PreviewTypingLabel1: PreviewLabel1,
                    "duration": "5"
                },
            },
            {
                "$": {
                    "text": this.isTyping ? PreviewTypingLabel2: PreviewLabel2,
                    "duration": "5"
                },
            }
        ];

        players.push(blockTemplate);
        newScene.Player.Data[0].Scene[0].Players[0].Player = players;

        this.storeSelector.dispatch(actionAddScene({player: newScene as IPlayerProps}));
        return sceneId;
    }
}
